module.exports = __webpack_public_path__ + "img/levelup-logout-black.f8f78b66.svg";